import { Component, ElementRef } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ToasterServiceService } from '../../service/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { ApiUrls } from '../../apiRouts';
import { environment } from '../../../environments/environment';
import lgZoom from 'lightgallery/plugins/zoom';
import { LightGallery } from 'lightgallery/lightgallery';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';


@Component({
  selector: 'app-photo-video-list',
  templateUrl: './photo-video-list.component.html',
  styleUrl: './photo-video-list.component.scss'
})
export class PhotoVideoListComponent {
  uploadForm: any = FormGroup;
  galleryFlag: any;
  galleryFolderId: any;
  fileToUpload: any;
  showButtonFlag: boolean = false;
  Label: any;
  formate: any;
  submitted: boolean = false;
  photoGallery: any = [];
  private lightGallery!: LightGallery;
  items: any[] = [];
  private needRefresh = false;
  baseUrl = environment.galleryURL;
  settings = {
    counter: false,
    dynamic: true,
    dynamicEl: this.items,
    plugins: [lgZoom, lgThumbnail, lgVideo]
  };
  // onBeforeSlide = (detail: BeforeSlideDetail): void => {
  //   const { index, prevIndex } = detail;
  // };
  constructor(private location: Location,
    private mainService: MainService,
    private route: ActivatedRoute,
    private toasterService: ToasterServiceService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private elementRef: ElementRef) {

    this.uploadForm = this.fb.group({
      src: ['', [Validators.required]],
    });

    this.route.params.subscribe((params: any) => {
      this.galleryFlag = params['flag'] || '';      
      this.galleryFolderId = params['gallery_folder_id'] || '';
    });
    this.Label = this.galleryFlag == 1 ? ' ફોટો ' : 'વિડિયો'
    this.formate = this.galleryFlag == 1 ? 'image/gif,image/jpeg,image/jpg,image/png' : ".mp4,.mpg,.m4v,.flv,.avi,.mov,.wmv,.divx,.f4v,.mpeg,.vob"
  }

  ngOnInit(): void {
    this.getPhotoOrVideo();
  }

  get f() {
    return this.uploadForm.controls;
  }

  ngAfterViewInit(): void {
    const galleryElement = this.elementRef.nativeElement.querySelector('#gallery');
    if (galleryElement) {
      lightGallery(galleryElement, {
        selector: 'a',
        mode: 'lg-fade',
        download: true,
        plugins: [lgZoom, lgThumbnail, lgVideo],
      });
    }
  }

  ngAfterViewChecked(): void {
    if (this.needRefresh && this.lightGallery) {
      this.lightGallery.refresh(this.items);
      this.lightGallery.openGallery();
      this.needRefresh = false;
    }
  }

  AddMemoryPhotoOrVideo() {
    this.submitted = true;
    if (this.uploadForm.valid) {
      if (this.galleryFlag == 1) {
        var data: any = {
          gallery_id: 0,
          image_src: '',
          gallery_folder_id: Number(this.galleryFolderId),
          Action: 'INSERT'
        }
        this.mainService.postApi(ApiUrls.addGallery, data, 1).subscribe((res: any) => {
          if (res.status == 1) {
            let formData = new FormData();
            formData.append('gallery_id', res.gallery[0].gallery_id);
            formData.append('image_src_file', this.fileToUpload);
            this.mainService.postFormDataApi(ApiUrls.addPhotoInGallery, formData, 1).subscribe((res: any) => {
              if (res.status == 1) {
                this.getPhotoOrVideo();
                this.toasterService.toastSuccess(res.response);
                this.submitted = false;
                this.uploadForm.reset();
              } else {
                this.toasterService.toastError(res.response);
              }
            });
          }
        });
      } else {
        var data: any = {
          video_gallery_id: 0,
          video_src: this.uploadForm.value.src,
          gallery_folder_id: Number(this.galleryFolderId),
          Action: 'INSERT'
        }
        this.mainService.postApi(ApiUrls.addVideoGallery, data, 1).subscribe((res: any) => {
          if (res.status == 1) {
            this.getPhotoOrVideo();
            this.toasterService.toastSuccess(res.response);
            this.submitted = false;
            this.uploadForm.reset();

            // let formData = new FormData();
            // formData.append('video_gallery_id', res.video_gallery[0].video_gallery_id);
            // formData.append('video_src_file', this.fileToUpload);
            // this.mainService.postFormDataApi(ApiUrls.uploadVideoGallery, formData, 0).subscribe((res: any) => {
            //   if (res.status == 1) {
            //     this.getPhotoOrVideo();
            //     this.toasterService.toastSuccess(res.response);
            //     this.submitted = false;
            //     this.uploadForm.reset();
            //   } else {
            //     this.toasterService.toastError(res.response);
            //   }
            // });
          }
        });
      }
    }
  }

  getPhotoOrVideo() {
    if (this.galleryFlag == 1) {
      this.mainService.getApi(ApiUrls.getGalleryPhoto + this.galleryFolderId).subscribe((res: any) => {
        if (res.status == 1) {
          if (res.gallery.length > 0) {
            this.items = res.gallery.map((item: any) => ({
              src: this.baseUrl + (item.image_src_file || item.image_src),
              thumb: this.baseUrl + (item.image_src_file || item.image_src),
            }));
            this.needRefresh = true;
            this.showButtonFlag = true;
          } else {
            this.showButtonFlag = false;
          }
        }
      });
    } else {
      this.mainService.getApi(ApiUrls.getGalleryVideo + this.galleryFolderId).subscribe((res: any) => {
        if (res.status == 1) {
          if (res.video_gallery.length > 0) {
            this.items = res.video_gallery.map((item: any) => ({
              src: this.baseUrl + (item.video_src || item.video_src),
              thumb: this.baseUrl + (item.video_src || item.video_src),
            }));
            this.needRefresh = true;
            this.showButtonFlag = true;
          } else {
            this.showButtonFlag = false;
          }
        }
      });
    }
  }
  onInit = (detail: any): void => {
    this.lightGallery = detail.instance;
  };

  openGallery = (): void => {
    if (this.lightGallery && this.showButtonFlag == true) {
      this.lightGallery.openGallery();
    } else {
      this.toasterService.toastError('ફોટો અને વિડિયો મળ્યા નથી.')
    }
  };

  getImage(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.fileToUpload = event.target.files[0];
      this.uploadForm.controls['src'].setValue(file);
    }
  }

  goBackToPrevPage() {
    this.location.back();
  }
}
